<template>
  <main class="login">
    <section class="login__modal" v-if="!showSuccess">
      <h2 class="login__title">{{ L.localize('Account_Breadcrumb_Register') }}</h2>

      <form class="form js-form" data-form="login" @keydown.enter.prevent="send" @keyup.enter="send" v-if="!showSuccess">

        <span class="form__validation" v-if="error">
          {{ error }}
        </span>

        <TextBox
            label="Label_EmailAddress"
            v-model="model.email"
            :validate="$v.model"
            @input="$v.model.email.$touch"
            modelPath="email"
            acc="email"
            type="email"
          />

        <TextBox
            label="Label_Password"
            v-model="model.password"
            :validate="$v.model"
            @input="$v.model.password.$touch"
            modelPath="password"
            acc="password"
            type="password"
          />

          <TextBox
            label="Label_ConfirmPassword"
            v-model="model.confirmPassword"
            :validate="$v.model"
            @input="$v.model.confirmPassword.$touch"
            modelPath="confirmPassword"
            acc="confirmPassword"
            type="password"
          />

        <Btn :isLoading="loading" @click="send" label="Account_Breadcrumb_Register" />

      </form>
    </section>
     <div class="login__modal" v-else>
        <span class="form__success">
          {{ L.localize("Account_ResetPassword_Text") }}
        </span>

        <Btn @click="gotoLogin" label="Login_LoginButton" />
      </div>
  </main>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { TextBox, Btn, CheckBox } from 'components/layout/forms'
  import L from 'services/Localization'
  import { Validation } from 'components/helpers'
  import { required, sameAs } from 'vuelidate/lib/validators'

  export default {
    name: 'Register',
    components: { Validation, TextBox, Btn, CheckBox },
    data() {
      return {
        loading: false,
        error: '',
        L: L,
        showSuccess: false,
        model: {
          email: '',
          password: '',
          confirmPassword: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        validation: 'getValidation'
      })
    },
    validations: {
      model: {
        email: { required },
        password: { required },
        confirmPassword: {
          required,
          sameAs: sameAs('password')
        }
      }
    },
    methods: {
      send: function() {
        if (this.$v.$invalid) {
          this.$v.$touch()
          return
        }
        this.loading = true
        this.$parent.callAPI('POST', '/account/register', {
          Password: this.model.password,
          Email: this.model.email
        }).then(
          // success
          () => {
            // do nothing, application will redirect
          },

          // fail
          (e, reponse) => {
            this.loading = false
            if (e.details) {
              this.error = L.localize(e.details)
            } else {
              this.error = L.localize(e.message)
            }
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Register.vue?bd0deaf4